import { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../layout/Layout";
import { getInvoices } from "../../../actions/admin/invoice";
import InvoicesTable from "./_components/InvoicesTable";
import InvoicesFilter from "./_components/InvoicesFilter";

const InvoiceList = () => {
  const dispatch = useDispatch();
  const { invoices, loading } = useSelector((state) => state.invoice);

  const [search, setSearch] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const withPageReset = (setter) => (value) => {
    setCurrentPage(1);
    setter(value);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      dispatch(
        getInvoices({
          page: currentPage,
          limit: pageSize,
          year,
          month,
          paymentStatus,
          search,
        })
      );
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [dispatch, search, month, year, paymentStatus, currentPage, pageSize]);

  const recordsTotal = invoices?.recordsTotal || 0;
  const totalPages = Math.max(1, Math.ceil(recordsTotal / pageSize));

  return (
    <Layout>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 tw:pb-[42px] w-100">
        <div className="tw:font-hanken-grotesk tw:text-[#212529]">
          <div className="tw:pt-[34px]">
            <div className="tw:mb-0 tw:font-hanken-grotesk tw:text-[22px] tw:font-semibold tw:leading-[normal] tw:text-[#212529]">
              Invoices
            </div>
            <div className="tw:mt-[34px] tw:h-px tw:w-full tw:bg-[#E6E6E6]" />
          </div>

          <InvoicesFilter
            search={search}
            setSearch={withPageReset(setSearch)}
            month={month}
            setMonth={withPageReset(setMonth)}
            year={year}
            setYear={withPageReset(setYear)}
            paymentStatus={paymentStatus}
            setPaymentStatus={withPageReset(setPaymentStatus)}
          />

          <Fragment>
            <InvoicesTable
              rows={invoices?.data || []}
              startIndex={(currentPage - 1) * pageSize}
              loading={loading}
              skeletonRowCount={pageSize}
            />
            {!loading && (
              <div className="pagination-container py-3 bg-white border-top">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    Showing {recordsTotal ? (currentPage - 1) * pageSize + 1 : 0} to{" "}
                    {recordsTotal ? Math.min(currentPage * pageSize, recordsTotal) : 0} of{" "}
                    {recordsTotal} entries
                  </div>
                  <div>
                    <nav aria-label="Invoice pagination">
                      <ul className="pagination mb-0">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                          >
                            Previous
                          </button>
                        </li>

                        {[...Array(Math.min(5, totalPages))].map((_, index) => {
                          let pageNum;
                          if (totalPages <= 5) {
                            pageNum = index + 1;
                          } else if (currentPage <= 3) {
                            pageNum = index + 1;
                          } else if (currentPage >= totalPages - 2) {
                            pageNum = totalPages - 4 + index;
                          } else {
                            pageNum = currentPage - 2 + index;
                          }

                          return (
                            <li
                              key={pageNum}
                              className={`page-item ${currentPage === pageNum ? "active" : ""}`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(pageNum)}
                              >
                                {pageNum}
                              </button>
                            </li>
                          );
                        })}

                        <li
                          className={`page-item ${
                            currentPage === totalPages || totalPages === 0 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                            }
                            disabled={currentPage === totalPages || totalPages === 0}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div>
                    <select
                      className="form-select form-select-sm"
                      value={pageSize}
                      onChange={(e) => {
                        setPageSize(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      <option value="10">10 per page</option>
                      <option value="25">25 per page</option>
                      <option value="50">50 per page</option>
                      <option value="100">100 per page</option>
                    </select>
                  </div>
                </div>
              </div>
            )}
          </Fragment>
        </div>
      </main>
    </Layout>
  );
};

export default InvoiceList;
